module.exports = "/_next/static/images/hero-devices-3e3fc7542673ee4a412ba15f13dbf7a0.png";